export const gossipCategories = [
  { slug: "all", name: "全部瓜料", desc: "不挑口味，从热到冷全都在这", icon: "ri-fire-line", count: 48 },
  { slug: "romance", name: "恋情绯闻", desc: "同框、取关、深夜同行", icon: "ri-heart-3-line", count: 14 },
  { slug: "backstage", name: "影视幕后", desc: "换角、改剧本、片场花絮", icon: "ri-clapperboard-line", count: 11 },
  { slug: "variety", name: "综艺现场", desc: "名场面、剪辑争议、嘉宾反应", icon: "ri-mic-2-line", count: 9 },
  { slug: "music", name: "音乐动态", desc: "歌单、现场、巡演与演出事故", icon: "ri-music-2-line", count: 7 },
  { slug: "idol", name: "选秀爱豆", desc: "解约、番位、粉丝应援前线", icon: "ri-star-smile-line", count: 5 },
  { slug: "redcarpet", name: "红毯活动", desc: "造型、站位、采访名场面", icon: "ri-vip-diamond-line", count: 2 },
];

export const gossipTopics = [
  {
    id: "top-lx-nanxing",
    title: "顶流L姓男星深夜同框聚餐，工作室回应「只是老友聚会」",
    category: "恋情绯闻",
    categorySlug: "romance",
    mask: "L姓男星 × 同组女演员",
    summary:
      "有网友深夜在商圈拍到一位顶流男星与同组女演员先后进入同一家餐厅，直到凌晨才分批离开。工作室次日凌晨发声，称是「老友聚会，请勿过度解读」。",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20city%20night%20street%20corner%20outside%20a%20quiet%20restaurant%2C%20soft%20amber%20street%20lamps%20and%20blurred%20neon%20reflections%2C%20empty%20sidewalk%20with%20a%20parked%20car%2C%20moody%20cinematic%20editorial%20photography%2C%20mostly%20dark%20warm%20neutral%20tones%20with%20a%20hint%20of%20red%2C%20no%20people%20in%20frame&width=1200&height=700&seq=gossip-lx-night-01&orientation=landscape",
    heat: 9821,
    comments: 1264,
    publishedAt: "09-08 23:40",
    date: "2026-09-08",
    source: "网友投稿 · 商圈街拍",
    credibility: "待回应",
    tags: ["顶流男星", "聚餐同框", "工作室回应", "深夜街拍"],
    highlights: [
      { label: "爆料时间", value: "09-08 23:40" },
      { label: "讨论量", value: "1,264 条" },
      { label: "证据完整度", value: "中 · 仅远景照片" },
      { label: "官方回应", value: "已回应（否认）" },
    ],
    timeline: [
      { time: "09-08 22:10", text: "网友发帖称在商圈餐厅外拍到两人先后入场，照片为远景，未拍到正脸。" },
      { time: "09-08 23:40", text: "多条搬运帖扩散，话题冲上讨论榜前列，评论区出现两派观点。" },
      { time: "09-09 01:20", text: "工作室发布简短声明，表示「普通老友聚会，请勿过度解读，恶意揣测将保留追责权利」。" },
      { time: "09-09 08:30", text: "同剧组工作人员在社交平台晒出多人合照，称当晚是剧组聚餐。" },
    ],
    content: [
      "事情的起点并不复杂：一位网友在商圈吃饭时，看到两位熟悉的面孔先后走进同一家餐厅，出于好奇拍了几张远景照片发到讨论区。因为其中一位是近两年热度极高的顶流男星，帖子在半小时内就被大量搬运。",
      "从目前流传的照片来看，画面里只能辨认出轮廓和衣着，没有正脸、没有同框特写，也没有牵手之类的明确动作。所以这次讨论的性质更接近「网友猜测」，而不是「实锤」。有经常做街拍的网友也提醒，餐厅门口那个位置本来就人来人往，单凭先后进入很难说明什么。",
      "值得注意的反而是时间线。当晚同剧组正在附近补拍夜戏，收工后一起吃饭是常见操作。第二天上午，剧组工作人员晒出的多人合照基本能对上时间。也就是说，「老友聚会」这个说法并不算突兀。",
      "不过讨论并没有因此停下来。一派网友认为工作室回应太快、太标准，反而像在提前灭火；另一派则觉得，如果真是剧组聚餐，那这波讨论属于典型的「看图说话」。评论区吵得最凶的其实是那个老问题：没有正脸的街拍，到底算不算证据？",
    ],
    related: ["top-guzhuang-huanjiao", "top-lianzong-fenshou"],
  },
  {
    id: "top-guzhuang-huanjiao",
    title: "古装热播剧女主疑遭临阵换角，制片方回应「档期冲突」",
    category: "影视幕后",
    categorySlug: "backstage",
    mask: "S姓女主 × 制作公司",
    summary:
      "一部正在热播的古装剧被扒出女主戏份集中在前期，后期大量使用替身与背影。有自称剧组人员的网友称，女主在拍摄中途被「温和换角」，制片方则回应是档期冲突。",
    cover:
      "https://readdy.ai/api/search-image?query=Empty%20traditional%20Chinese%20period%20drama%20film%20set%20at%20dusk%2C%20wooden%20palace%20corridor%20and%20paper%20lanterns%2C%20costume%20racks%20and%20camera%20equipment%20left%20on%20the%20ground%2C%20warm%20dusty%20golden%20light%2C%20muted%20terracotta%20and%20cream%20palette%2C%20no%20people%20in%20frame%2C%20cinematic%20wide%20shot&width=1200&height=700&seq=gossip-guzhuang-set-01&orientation=landscape",
    heat: 8740,
    comments: 918,
    publishedAt: "09-07 18:05",
    date: "2026-09-07",
    source: "网友投稿 · 自称剧组人员",
    credibility: "双方说法不一",
    tags: ["古装剧", "换角", "档期冲突", "替身"],
    highlights: [
      { label: "爆料时间", value: "09-07 18:05" },
      { label: "讨论量", value: "918 条" },
      { label: "证据完整度", value: "中 · 截图为主" },
      { label: "官方回应", value: "已回应（档期冲突）" },
    ],
    timeline: [
      { time: "09-07 16:20", text: "有网友整理出女主戏份分布，指出第 18 集后大量镜头为背影与远景。" },
      { time: "09-07 18:05", text: "自称剧组人员的网友发帖，称女主在中途与片方产生分歧并减少进组。" },
      { time: "09-08 10:40", text: "制片方回应：不存在换角，女主因后续项目档期冲突，部分补拍由替身完成。" },
      { time: "09-08 21:15", text: "女主工作室转发回应并附了一句「谢谢大家关心」，未正面说明细节。" },
    ],
    content: [
      "追剧的人往往比剪辑师更敏锐。有网友一边追一边截图，发现女主的正脸镜头在第 18 集之后明显减少，取而代之的是替身背影、远景走位和大量台词画外音。这个观察本身就很有说服力，因为它不是靠爆料，而是靠成片证据。",
      "随后出现的「剧组人员」帖子，把事情推向另一个方向。该网友称女主在拍摄中期与片方在人物走向上有过分歧，之后进组频率下降。但这个说法没有任何合同、通告单之类的硬材料，属于典型的单方面叙述。",
      "制片方的回应相对完整一些：档期冲突、补拍由替身完成、不存在换角。从行业惯例看，「档期冲突导致补拍用替身」确实是真实存在的操作，尤其在多组同步拍摄的长剧里很常见。",
      "真正让讨论持续升温的，是女主工作室那句「谢谢大家关心」。在吃瓜语境里，越模糊的回应越容易被解读成各种版本。所以目前这一条的状态是：双方都说话了，但拼不出一张完整的图。",
    ],
    related: ["top-lx-nanxing", "top-zongyi-jianji"],
  },
  {
    id: "top-lianzong-fenshou",
    title: "恋综人气CP疑似互相取关，节目组连夜删除花絮",
    category: "综艺现场",
    categorySlug: "variety",
    mask: "恋综人气CP",
    summary:
      "一档恋爱综艺里圈粉无数的「人气CP」被网友发现社交账号疑似互相取关，同时节目组官号连夜下架了多条两人花絮。截至发稿，双方均未回应。",
    cover:
      "https://readdy.ai/api/search-image?query=Soft%20romantic%20studio%20variety%20show%20set%20with%20two%20empty%20chairs%20and%20warm%20string%20lights%2C%20pastel%20cream%20and%20dusty%20rose%20backdrop%20with%20blurred%20bokeh%2C%20camera%20rig%20at%20the%20side%2C%20cozy%20editorial%20photography%2C%20no%20people%20in%20frame%2C%20gentle%20muted%20color%20grade&width=1200&height=700&seq=gossip-lianzong-01&orientation=landscape",
    heat: 7932,
    comments: 842,
    publishedAt: "09-06 21:30",
    date: "2026-09-06",
    source: "网友发现 · 账号动态比对",
    credibility: "热议中",
    tags: ["恋综", "CP", "取关", "花絮下架"],
    highlights: [
      { label: "爆料时间", value: "09-06 21:30" },
      { label: "讨论量", value: "842 条" },
      { label: "证据完整度", value: "低 · 仅账号动态" },
      { label: "官方回应", value: "暂未回应" },
    ],
    timeline: [
      { time: "09-06 19:00", text: "有网友整理两人主页动态，指出曾经互相标记的内容消失。" },
      { time: "09-06 21:30", text: "节目组官号被发现在两小时内陆续隐藏多条双人花絮视频。" },
      { time: "09-07 09:10", text: "话题发酵，CP 超话内出现明显分歧，一部分粉丝呼吁「别添乱」。" },
      { time: "09-07 20:00", text: "双方工作室均未发声，节目组也未就下架花絮给出说明。" },
    ],
    content: [
      "这一条最典型的地方在于：证据全是「间接证据」。网友能看到的只是账号动态的变化和官号的删帖行为，没有人拍到任何画面，也没有任何一方出来说话。",
      "但「官号连夜删花絮」这个动作，在讨论区里被当成了最有力的信号。因为对恋综来说，双人花絮就是CP粉的命根子，正常情况下非但不会删，还会反复推送。所以一旦出现批量下架，大家的联想方向就都一致了。",
      "也有理性派提醒：节目收官后清理版权素材、调整合集是常规操作，时间点凑巧而已。这种说法站得住脚，但在吃瓜语境里往往说服力有限。",
      "目前比较稳妥的结论是——「关系是否生变」无法确认，但「节目组的运营动作确实反常」是客观事实。至于真相，可能只有当事人自己知道。",
    ],
    related: ["top-lx-nanxing", "top-yinyuejie-gedan"],
  },
  {
    id: "top-yinyuejie-gedan",
    title: "音乐节压轴歌手临时改歌单，现场粉丝集体合唱救场",
    category: "音乐动态",
    categorySlug: "music",
    mask: "音乐节压轴歌手",
    summary:
      "一场音乐节因设备故障导致压轴歌手临时调整歌单，删掉两首高难度曲目。现场粉丝在返场环节自发合唱，被不少观众称为当晚最好的「安可」。",
    cover:
      "https://readdy.ai/api/search-image?query=Large%20outdoor%20music%20festival%20stage%20at%20night%20seen%20from%20the%20crowd%2C%20warm%20amber%20stage%20lights%20and%20haze%2C%20empty%20microphone%20stand%20at%20center%2C%20confetti%20in%20the%20air%2C%20cinematic%20concert%20photography%2C%20deep%20warm%20tones%20with%20terracotta%20highlights%2C%20no%20recognizable%20people&width=1200&height=700&seq=gossip-yinyuejie-01&orientation=landscape",
    heat: 6218,
    comments: 507,
    publishedAt: "09-05 23:55",
    date: "2026-09-05",
    source: "现场观众投稿",
    credibility: "已澄清 · 设备故障",
    tags: ["音乐节", "歌单调整", "设备故障", "安可合唱"],
    highlights: [
      { label: "爆料时间", value: "09-05 23:55" },
      { label: "讨论量", value: "507 条" },
      { label: "证据完整度", value: "高 · 多机位现场视频" },
      { label: "官方回应", value: "主办方已致歉说明" },
    ],
    timeline: [
      { time: "09-05 21:40", text: "压轴环节开始前，舞台返听设备出现异常，演出延后约十二分钟。" },
      { time: "09-05 22:05", text: "歌手登台并临时调整歌单，跳过两首编曲复杂的曲目。" },
      { time: "09-05 23:10", text: "返场环节全场自发合唱，视频在当晚被大量转发。" },
      { time: "09-06 12:00", text: "主办方发布说明，承认设备问题并致歉，承诺后续场次升级返听系统。" },
    ],
    content: [
      "这一条和常见的「撕」完全不同，它更像一个意外现场记录。设备出问题——调整歌单——观众合唱补上，整个过程大家都看在眼里，所以争议反而很小。",
      "从现场视频能清楚看到，返听在开场前就有杂音，工作人员来回检查了几次。歌手登台后和乐手沟通了将近一分钟才起第一首，这种临场反应在音乐节并不罕见。",
      "被跳过的两首恰好是编曲最复杂、对返听依赖最高的曲目，从专业角度看是合理的取舍。有乐手在评论区解释：听不清自己唱什么的时候硬上高难度歌，翻车概率反而更高。",
      "最出圈的还是那个安可。前奏没响，台下先唱起来了，然后是全场。有人说是「最好的救场」，也有人说是「粉丝滤镜」，但不管怎么解读，那个画面确实是当晚传播最广的一段。",
    ],
    related: ["top-lianzong-fenshou", "top-yingdi-luyan"],
  },
  {
    id: "top-zongyi-jianji",
    title: "综艺名场面被剪成三秒，嘉宾发文「有些话确实不能说」",
    category: "综艺现场",
    categorySlug: "variety",
    mask: "综艺常驻嘉宾",
    summary:
      "一期综艺节目里，一段明显被大幅删减的互动只剩下三秒画面，引发观众猜测。次日有嘉宾在社交平台发文「有些话确实不能说」，让讨论进一步升温。",
    cover:
      "https://readdy.ai/api/search-image?query=Empty%20television%20studio%20set%20with%20a%20long%20table%20and%20colorful%20director%20chairs%2C%20overhead%20studio%20lights%20and%20a%20large%20blurred%20LED%20screen%2C%20warm%20cream%20and%20soft%20amber%20tones%2C%20subtle%20teal%20accent%20lighting%2C%20editorial%20photography%2C%20no%20people%20in%20frame&width=1200&height=700&seq=gossip-zongyi-cut-01&orientation=landscape",
    heat: 5904,
    comments: 476,
    publishedAt: "09-09 12:15",
    date: "2026-09-09",
    source: "网友逐帧比对",
    credibility: "热议中",
    tags: ["综艺剪辑", "名场面", "放送事故", "嘉宾发文"],
    highlights: [
      { label: "爆料时间", value: "09-09 12:15" },
      { label: "讨论量", value: "476 条" },
      { label: "证据完整度", value: "中 · 预告片与正片对比" },
      { label: "官方回应", value: "暂未回应" },
    ],
    timeline: [
      { time: "09-09 10:00", text: "有网友把预告片和正片做逐帧对比，指出一段互动被压缩到只剩三秒。" },
      { time: "09-09 12:15", text: "参与该期录制的嘉宾发文「有些话确实不能说」，随后未再补充。" },
      { time: "09-09 16:40", text: "节目官微更新了一条常规宣传，未回应剪辑争议。" },
      { time: "09-10 09:00", text: "讨论度回落，但相关切片视频仍在持续传播。" },
    ],
    content: [
      "「预告里明明有的东西，正片里没了」——这是观众最直观的不满，也是这次讨论的起点。做对比图的网友很专业，把预告、正片、花絮三段拼在一起，差异一目了然。",
      "随后嘉宾那句「有些话确实不能说」，直接把这件小事变成了一次公开猜测。支持节目组的人认为，综艺剪辑本来就要考虑时长和内容尺度；另一派则觉得，把一段完整互动剪成三秒、连逻辑都不连贯，属于基本剪辑失误。",
      "客观地说，综艺剪辑的删改原因可以有很多：时长、审核、节奏、甚至单纯是素材版本不同。但观众看不到过程，只能看到结果，所以任何一句模糊的表态都会被放大。",
      "截至目前，节目组和嘉宾都没有进一步说明。以经验判断，这类讨论通常会在下一期播出后自然消退，除非有人再补一刀。",
    ],
    related: ["top-guzhuang-huanjiao", "top-xuanxiu-jieyue"],
  },
  {
    id: "top-yingdi-luyan",
    title: "影帝新片路演突发落泪，应援被指越界引发两派争论",
    category: "音乐动态",
    categorySlug: "music",
    mask: "影帝 & 应援团",
    summary:
      "一位影帝在新片路演现场谈及角色经历时一度哽咽落泪，现场应援灯光与口号被部分观众认为影响了观影秩序，引发关于应援尺度的讨论。",
    cover:
      "https://readdy.ai/api/search-image?query=Empty%20cinema%20auditorium%20with%20rows%20of%20red%20velvet%20seats%20and%20a%20softly%20lit%20blank%20screen%2C%20warm%20amber%20wall%20sconces%2C%20muted%20cream%20and%20terracotta%20palette%2C%20a%20single%20spotlight%20on%20the%20stage%2C%20cinematic%20editorial%20photography%2C%20no%20people%20in%20frame&width=1200&height=700&seq=gossip-luyan-hall-01&orientation=landscape",
    heat: 5310,
    comments: 388,
    publishedAt: "09-04 20:10",
    date: "2026-09-04",
    source: "现场观众投稿",
    credibility: "已澄清 · 现场秩序正常",
    tags: ["路演", "应援", "观影秩序", "落泪瞬间"],
    highlights: [
      { label: "爆料时间", value: "09-04 20:10" },
      { label: "讨论量", value: "388 条" },
      { label: "证据完整度", value: "高 · 现场多角度视频" },
      { label: "官方回应", value: "影院方称秩序正常" },
    ],
    timeline: [
      { time: "09-04 19:30", text: "路演映后交流开始，现场出现集中应援灯光与口号。" },
      { time: "09-04 20:10", text: "主创谈及角色经历时一度哽咽，视频片段迅速扩散。" },
      { time: "09-04 22:00", text: "有观众发帖反映应援影响了观影，引发两派争论。" },
      { time: "09-05 11:00", text: "影院方回应称当日秩序正常，映后环节按流程结束。" },
    ],
    content: [
      "这一条的讨论点其实有两个：一个是情绪，一个是秩序。前者让视频出圈，后者才是争论的核心。",
      "先说情绪。主创在谈到角色经历时停顿了几秒，然后哽咽，这个瞬间被现场观众完整记录。对电影宣传来说，这样的真情实感通常会被视为加分项。",
      "再说秩序。有观众反映应援灯光在放映期间亮起，影响了后排体验。但影院方后续回应，映后交流环节本身就不涉及放映，所谓「影响观影」发生在散场后的交流时段。这个回应基本解开了争议。",
      "剩下的就是老生常谈的尺度问题：应援到什么程度算热情，到什么程度算打扰。这个问题没有标准答案，但至少在这一场，官方给出的结论是「没有越界」。",
    ],
    related: ["top-yinyuejie-gedan", "top-redcarpet-zhanwei"],
  },
  {
    id: "top-xuanxiu-jieyue",
    title: "选秀出身爱豆解约风波升级，前后公司各执一词",
    category: "选秀爱豆",
    categorySlug: "idol",
    mask: "选秀出身爱豆 × 两家公司",
    summary:
      "一位选秀出身的爱豆被传与原经纪公司解约，新公司已开始承接商务。原公司称合约仍在有效期内，新公司则表示手续合规，双方各执一词。",
    cover:
      "https://readdy.ai/api/search-image?query=Close%20up%20of%20a%20blank%20contract%20document%20and%20a%20pen%20on%20a%20warm%20wooden%20desk%2C%20soft%20window%20light%2C%20minimal%20cream%20and%20terracotta%20color%20scheme%2C%20shallow%20depth%20of%20field%2C%20clean%20editorial%20still%20life%20photography%2C%20no%20readable%20text%20visible&width=1200&height=700&seq=gossip-idol-contract-01&orientation=landscape",
    heat: 4980,
    comments: 355,
    publishedAt: "09-03 15:20",
    date: "2026-09-03",
    source: "行业人士投稿",
    credibility: "双方说法不一",
    tags: ["解约", "合约纠纷", "经纪公司", "商务"],
    highlights: [
      { label: "爆料时间", value: "09-03 15:20" },
      { label: "讨论量", value: "355 条" },
      { label: "证据完整度", value: "中 · 双方声明" },
      { label: "官方回应", value: "双方均已发声" },
    ],
    timeline: [
      { time: "09-03 12:00", text: "有网友发现品牌方合作物料中，艺人所属公司信息已变更。" },
      { time: "09-03 15:20", text: "原经纪公司发布声明，称合约仍在有效期内，未同意解约。" },
      { time: "09-03 19:40", text: "新公司回应称一切手续合规，已正常承接商务合作。" },
      { time: "09-04 10:00", text: "相关品牌方暂未就归属问题给出说明。" },
    ],
    content: [
      "这类瓜看起来枯燥，但其实是行业内最常发生的一类争议：合约到底有没有结束。它不像恋情那样有画面感，却直接决定艺人后续所有工作能不能正常进行。",
      "从公开信息看，双方都只给了结论，没有给过程。原公司强调「合约有效」，新公司强调「手续合规」，两句话并不必然矛盾——因为合约纠纷里经常存在「一方认为已解约、另一方认为未解约」的情况。",
      "对品牌方来说，这属于典型的风险点。通常的做法是暂停新物料投放，等归属明确后再推进。所以接下来一段时间，这位艺人的商务节奏大概会明显放缓。",
      "讨论区里最理性的提醒是：这类事情最终看的是合同文本和司法结论，网友能做的只有等。但等的过程，往往比瓜本身更热闹。",
    ],
    related: ["top-zongyi-jianji", "top-guzhuang-huanjiao"],
  },
  {
    id: "top-redcarpet-zhanwei",
    title: "红毯站位引猜测，工作人员一句话解释清楚了",
    category: "红毯活动",
    categorySlug: "redcarpet",
    mask: "红毯同框艺人",
    summary:
      "某年度盛典红毯上，两位人气艺人的站位被截图放大解读。第二天现场工作人员在讨论区解释了走位安排，风波迅速平息。",
    cover:
      "https://readdy.ai/api/search-image?query=Elegant%20empty%20red%20carpet%20walkway%20at%20an%20award%20ceremony%2C%20warm%20cream%20and%20terracotta%20backdrop%20with%20gold%20accent%20lighting%2C%20rope%20barriers%20and%20camera%20positions%20at%20the%20sides%2C%20cinematic%20editorial%20photography%2C%20no%20people%20in%20frame&width=1200&height=700&seq=gossip-redcarpet-01&orientation=landscape",
    heat: 4120,
    comments: 264,
    publishedAt: "09-02 22:40",
    date: "2026-09-02",
    source: "现场图集比对",
    credibility: "已澄清",
    tags: ["红毯", "站位", "同框", "盛典"],
    highlights: [
      { label: "爆料时间", value: "09-02 22:40" },
      { label: "讨论量", value: "264 条" },
      { label: "证据完整度", value: "高 · 现场多角度图" },
      { label: "官方回应", value: "工作人员已说明" },
    ],
    timeline: [
      { time: "09-02 21:50", text: "盛典红毯直播进行，两位人气艺人先后登场。" },
      { time: "09-02 22:40", text: "有网友截图对比站位，猜测两人关系微妙。" },
      { time: "09-03 10:30", text: "现场工作人员在讨论区说明，走位按主办方名单顺序安排。" },
      { time: "09-03 12:00", text: "讨论迅速平息，多数网友表示「确实是过度解读」。" },
    ],
    content: [
      "红毯站位是吃瓜领域最经典的「显微镜现场」。一张图能同时容纳灯光、顺序、眼神、距离，几乎每个细节都能被赋予含义。",
      "这次的起因很简单：直播画面里两人没有并排，中间隔了一位主持人。截图传播开后，出现了各种解读。但只要看一眼当晚完整流程就会发现，红毯走位是按主办方名单顺序来的，前面还有一个合影环节被剪掉了。",
      "真正让风波收场的是工作人员那句说明——走位由主办方统一安排，艺人不参与。有了这句话，之前的猜测就失去了基础。",
      "所以这一条最终结论是：没有瓜，就是一场典型的「截图害人」。也算给喜欢放大细节的朋友提个醒，单张图能说明的东西，比想象中少。",
    ],
    related: ["top-yingdi-luyan", "top-lx-nanxing"],
  },
];

export const hotSearchList = [
  { rank: 1, keyword: "L姓男星工作室回应", tag: "爆", topicId: "top-lx-nanxing" },
  { rank: 2, keyword: "古装剧女主戏份分布", tag: "热", topicId: "top-guzhuang-huanjiao" },
  { rank: 3, keyword: "恋综CP互相取关", tag: "热", topicId: "top-lianzong-fenshou" },
  { rank: 4, keyword: "综艺名场面被剪三秒", tag: "新", topicId: "top-zongyi-jianji" },
  { rank: 5, keyword: "音乐节压轴改歌单", topicId: "top-yinyuejie-gedan" },
  { rank: 6, keyword: "选秀爱豆解约风波", topicId: "top-xuanxiu-jieyue" },
  { rank: 7, keyword: "影帝路演落泪", topicId: "top-yingdi-luyan" },
  { rank: 8, keyword: "红毯站位真相", topicId: "top-redcarpet-zhanwei" },
];

export const topicComments = [
  {
    id: "c1",
    topicId: "top-lx-nanxing",
    user: "蹲一个后续",
    avatarBg: "bg-primary-500",
    floor: 1,
    content: "先别急着下结论吧，远景照片连脸都看不清，怎么就直接定性了。我倒是觉得剧组聚餐更合理，时间线也对得上。",
    likes: 328,
    time: "09-09 02:14",
    replies: 26,
  },
  {
    id: "c2",
    topicId: "top-lx-nanxing",
    user: "吃瓜不加糖",
    avatarBg: "bg-secondary-500",
    floor: 2,
    content: "回应得也太快了吧，凌晨一点发声明，这效率放平时根本见不到。反正我持保留态度，等更多信息。",
    likes: 256,
    time: "09-09 02:40",
    replies: 41,
  },
  {
    id: "c3",
    topicId: "top-lx-nanxing",
    user: "理性看客",
    avatarBg: "bg-accent-600",
    floor: 3,
    content: "楼上的逻辑有点问题，出事了当然要快回应。要是不回应你们又该说心虚了，怎么做都是错是吧。",
    likes: 412,
    time: "09-09 08:02",
    replies: 19,
  },
  {
    id: "c4",
    topicId: "top-lx-nanxing",
    user: "夜班观察员",
    avatarBg: "bg-foreground-700",
    floor: 4,
    content: "剧组合照是真的，我个人倾向于就是聚餐。不过这波热度确实把同组其他演员也带上了，有点无辜。",
    likes: 187,
    time: "09-09 10:25",
    replies: 8,
  },
  {
    id: "c5",
    topicId: "top-lx-nanxing",
    user: "瓜田里的猹",
    avatarBg: "bg-primary-600",
    floor: 5,
    content: "总结一下：证据不足以支撑任何一方，大家看个乐呵就行。真正该讨论的是街拍边界问题。",
    likes: 145,
    time: "09-09 13:40",
    replies: 12,
  },
  {
    id: "c6",
    topicId: "top-guzhuang-huanjiao",
    user: "追剧二十年",
    avatarBg: "bg-secondary-600",
    floor: 1,
    content: "成片证据比任何爆料都硬。第18集之后正脸肉眼可见地变少，这个不需要谁来说，自己看就知道了。",
    likes: 402,
    time: "09-08 09:15",
    replies: 33,
  },
  {
    id: "c7",
    topicId: "top-guzhuang-huanjiao",
    user: "制片小白",
    avatarBg: "bg-accent-500",
    floor: 2,
    content: "档期冲突在长剧里真的很常见，多组同步拍摄，演员后面接戏了就只能靠替身补。不一定是撕。",
    likes: 288,
    time: "09-08 11:02",
    replies: 21,
  },
  {
    id: "c8",
    topicId: "top-guzhuang-huanjiao",
    user: "不吃解释",
    avatarBg: "bg-foreground-600",
    floor: 3,
    content: "工作室那句「谢谢大家关心」等于什么都没说。要么就好好回应，要么就别回应，这种最容易被带节奏。",
    likes: 231,
    time: "09-08 21:50",
    replies: 17,
  },
  {
    id: "c9",
    topicId: "top-lianzong-fenshou",
    user: "CP 粉蹲守中",
    avatarBg: "bg-primary-500",
    floor: 1,
    content: "删花絮真的太明显了，收官之后清理素材我知道，但没有一次是这么齐的。心里有点慌。",
    likes: 344,
    time: "09-07 00:30",
    replies: 52,
  },
  {
    id: "c10",
    topicId: "top-lianzong-fenshou",
    user: "冷静磕学家",
    avatarBg: "bg-secondary-500",
    floor: 2,
    content: "大家冷静点，恋综播完CP解绑是行业惯例，不代表真的怎么样。别自己脑补然后自己受伤。",
    likes: 298,
    time: "09-07 09:40",
    replies: 30,
  },
  {
    id: "c11",
    topicId: "top-yinyuejie-gedan",
    user: "现场第一排",
    avatarBg: "bg-accent-600",
    floor: 1,
    content: "当时就在台下，返听确实有问题，歌手一直在跟乐手比划。跳歌完全是无奈之举，但那个合唱真的绝了。",
    likes: 266,
    time: "09-06 01:20",
    replies: 14,
  },
  {
    id: "c12",
    topicId: "top-zongyi-jianji",
    user: "剪过片的人",
    avatarBg: "bg-secondary-700",
    floor: 1,
    content: "三秒剪辑一般是时长逼的，但通常会给个过渡。直接硬切确实容易看出问题，编导这次是偷懒了。",
    likes: 219,
    time: "09-09 15:30",
    replies: 11,
  },
];

export const faqItems = [
  {
    id: "f1",
    question: "「爆料吃瓜」上的内容是怎么来的？",
    answer:
      "主要来自网友投稿和公开信息的整理。我们会把同一事件的多条线索放在一起，标注时间线、来源和证据完整度，方便你快速判断。所有内容都属于网友讨论，不代表最终结论。",
  },
  {
    id: "f2",
    question: "为什么很多内容用的是「L姓」「S姓」这样的代号？",
    answer:
      "因为大部分爆料在当事人正式回应之前都缺乏确凿证据。使用代号既能保留讨论空间，也能避免对无关的人造成误伤。等到事件有明确结论，我们会更新标签。",
  },
  {
    id: "f3",
    question: "页面上的「证据完整度」是什么意思？",
    answer:
      "这是我们根据公开材料做的一个粗略分级：高（有多机位视频或成片对比）、中（有截图但缺乏关键画面）、低（仅有账号动态等间接信息）。它只是参考，不是判定标准。",
  },
  {
    id: "f4",
    question: "怎么参与讨论？可以自己投稿爆料吗？",
    answer:
      "可以。讨论区页面有投稿入口，填写事件大致经过、你觉得可信度如何、有没有公开可查的材料来源即可。请勿提交他人隐私信息或未经证实的指控。",
  },
  {
    id: "f5",
    question: "群聊和贴吧入口要怎么加入？",
    answer:
      "社群列表里每一列都会注明定位和当前状态。点击「获取入口」，留下你的联系方式，我们会按顺序发送邀请。为了保证讨论质量，满员或暂停的群会暂时关闭入口。",
  },
  {
    id: "f6",
    question: "发现内容有误可以反馈吗？",
    answer:
      "当然可以，也非常欢迎。你可以通过页面底部的邮箱联系我们，附上具体条目和更正依据。核实之后我们会修改内容，并在条目里标注更新记录。",
  },
];